import React from "react";
import { Link } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import Doctor from "../../assets/images/Doctor.png"
import "../SignupPages/SignupCommon.css";
import "./NadPlusCommon.css";

const NadPlusPage: React.FC = () => {
  return (
    <PageWrapper>
      <div className="signup-page-container">
        <div className="signup-content">
          <p className="signup-mainpage-para">
            Let’s begin with some simple questions.
          </p>
          <img className="signup-mainpage-img" src={Doctor} alt="doctor"/>
          <Link to="/nadplus/getting-started/step-1">
            <button className="next-btn">Get Started</button>
          </Link>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NadPlusPage;
